import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom';
import HomePage from '../homepage';
import NotFoundPage from '../not-found.page';
import StandardLayout from './standard-layout.component';
import CharactersPage from '../characters.page';
import PricingPage from '../pricing.page';
import CastPage from '../cast.page';
import ContactPage from '../contact.page';
import { Cast } from '@mui/icons-material';

export const StandardLayoutRouter = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<StandardLayout />}>
                {/* Nested routes */}
                {/* Home route */}
                <Route index element={<HomePage />} />
                <Route path="/characters" element={<CharactersPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/cast" element={<CastPage />} />
                <Route path="/contact" element={<ContactPage />} />
                {/* Catch-all route for 404 */}
                <Route path="*" element={<NotFoundPage />}/>
            </Route>
        </Routes>
    </BrowserRouter>
);

export default StandardLayoutRouter;